import { Injectable } from '@angular/core';
import {
  ApiCallHandler,
  EoHttpClient,
  IDataService,
  IHttpParams,
  PaginatedSearchResult,
  STATUS,
} from 'ngx-eo-web-components';
import { CoreService } from '../../modules/core/core.service';
import { ISortParams } from '../../modules/shared/models/sort.model';
import { Observable } from 'rxjs';
import { Surgery } from '../../modules/core/models/surgery.model';
import { SurgeryDoctor } from '../../modules/core/models/surgery-doctor.model';

@Injectable({
  providedIn: 'root',
})
export class SurgeryPrivateService implements IDataService<Surgery> {

  private searchParams: {
    hospitalID: string;
    clinicID: string | null;
    dateFrom: Date | null;
    dateTo: Date | null;
    patientAmka: string | null;
    sortParams?: ISortParams | null;
  } | null = null;

  constructor(private http: EoHttpClient, private coreService: CoreService) {}
  public searchCh = new ApiCallHandler<PaginatedSearchResult<Surgery> | null>();
  public surgeryCommunicationFailedCallHandler = new ApiCallHandler<any>();
  public surgeryFetchCallHandler = new ApiCallHandler<Surgery>();

  init() {
    this.searchCh.init();
    this.surgeryCommunicationFailedCallHandler.init(null);
    this.surgeryFetchCallHandler.init();
  }

  getSurgeryById(surgeryId: string) {
    const param: IHttpParams = this.coreService.initCall(
      `/v1/Surgeries/fetch/${surgeryId}`,
      this.surgeryFetchCallHandler
    );
    return this.http.get<Surgery>(param);
  }

  searchPrivateSurgeries(
    searchParams: {
      hospitalID: string;
      clinicID: string | null;
      dateFrom: Date | null;
      dateTo: Date | null;
      patientAmka: string | null;
      sortParams?: ISortParams | null;
    },
    pagesize: number,
    page: number
  ): Observable<PaginatedSearchResult<Surgery>> {

    // Save searchParams for reuse
    this.searchParams = searchParams;

    const param: IHttpParams = this.coreService.initCall(
      `/v1/Surgeries/searchPrivate/${pagesize}/${page}`,
      this.searchCh,
      searchParams
    );

    return this.http.post<PaginatedSearchResult<Surgery>>(param);
  }

  getSavedSearchParams() {
    return this.searchParams;
  }

  communicationFailedSurgery(surgeryCommunicationFailedBind: {
    surgeryID: string;
    surgeryCommunicationFailedComments: string | null;
  }) {
    const param: IHttpParams = this.coreService.initCall(
      '/v1/Surgeries/communicationFailed',
      this.surgeryCommunicationFailedCallHandler,
      surgeryCommunicationFailedBind
    );
    return this.http.post(param);
  }
  
}
